import { module } from 'modujs';
import { ScrollTrigger } from '../gsap'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        requestAnimationFrame(() => this.setScrollTrigger());

        window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setScrollTrigger() {

        // Retreive --header-size and transform it to Number
        const rootStyles = getComputedStyle(document.documentElement, null)
        const headerSize = parseInt(rootStyles.getPropertyValue('--header-height'), 10)
        const offset = `${headerSize/2}px`

        this.st = ScrollTrigger.create({
            trigger: this.el,
            start: `top-=${offset} top`,
            end: `bottom-=${offset} top`,
            onToggle: ({isActive}) => {
                this.call('toggleColor', isActive, 'Header')
            }
        })
    }

    resize() {
        this.st.kill()
        this.setScrollTrigger()
    }

    destroy() {
        this.st.kill()

        window.removeEventListener('resizeEnd', this.onResize)
    }
}
